import * as _ from 'lodash';
import * as types from './types';

const INITIAL_STATE = {
  allergens: [],
  allergenReport: null,
  allergenReportError: null,
  reportFetching: false,
  fieldsLoading: false,
  teachers: [],
  grades: [],
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.GET_ALLERGEN:
      let allergens = _.orderBy(
        action.payload.data.Data.map((item, index) => {
          return {
            value: item.Id,
            text: item.Description,
            key: index + 1,
          };
        }),
        [item => item.text.toLowerCase()]
      );

      allergens.unshift({ value: '0', text: 'ALL', key: 'valueALL' });

      return { ...state, allergens };
    case types.GET_ALLERGEN_TEACHERS:
      const data = action.payload.data.Data;
      let teachers = _.uniqBy(data, 'Teacher')
        .map((item, index) => {
          return {
            value: item.Teacher,
            key: index,
            text: item.Teacher,
          };
        })
        .filter(x => x.text.length > 0);

      teachers = _.orderBy(teachers, [item => item.value.toLowerCase()]);

      teachers.push({
        value: 'UNASSIGNED',
        text: 'UNASSIGNED',
        key: 'unassignedValue',
      });

      teachers.unshift({
        value: 'ALL',
        text: 'ALL',
        key: 'valueALL',
      });

      let grades = _.sortBy(_.uniqBy(data, 'GradeId'), 'GradeId').map(
        (item, index) => {
          return {
            value: item.GradeId,
            key: index,
            text: item.GradeId + ' ' + item.GradeDescription,
          };
        }
      );

      grades.unshift({
        value: 'ALL',
        text: 'ALL',
        key: 'valueALL',
      });

      return { ...state, teachers, grades };
    case types.GET_ALLERGEN_REPORT:
      const reportData = action.payload.data.Data;
      const allergenReport = !reportData ? 'No Data' : reportData;
      return { ...state, allergenReport };
    case types.GET_ALLERGEN_REPORT_ERROR:
      return { ...state, allergenReportError: action.payload };
    case types.CLEAR_REPORT_DATA:
      return { ...state, allergenReport: null, allergenReportError: null };
    case types.ALLERGEN_REPORT_LOAD:
      return { ...state, reportFetching: action.payload };
    case types.ALLERGEN_FIELDS_LOADING:
      return {
        ...state,
        fieldsLoading: action.payload,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/studentallergies/state/reducer.js